import React from 'react'

import { Box, Text, ToggleButton } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import SelectField from 'modules/core/components/SelectField'
import TextField from 'modules/core/components/TextField'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import type TimeoffCompensationForm from 'modules/timeoff/lib/TimeoffCompensationForm'

import { capacityUnitsOptions } from '../../utils/unitsOptions'

interface Props {
  form: TimeoffCompensationForm
}

const CompensationCapacity = ({ form }: Props) => {
  const [showCustomLimit, setShowCustomLimit] = React.useState(
    !form.isCompensationCapacityUnlimited()
  )

  React.useEffect(() => {
    setShowCustomLimit(!form.isCompensationCapacityUnlimited())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.get('has_unlimited_compensation').value])

  return (
    <Box gap="s16">
      <Box gap="s8">
        <Text size="200" color="grey1000" weight="medium">
          {i18n.t('time_tracking.settings.compensation.pool_capacity')}
        </Text>
        <Box flexDirection="row" gap="s8">
          <ToggleButton
            toggled={form.isCompensationCapacityUnlimited() && !showCustomLimit}
            onClick={() => {
              setShowCustomLimit(false)
              form.setValues({
                compensation_capacity: 0,
                has_unlimited_compensation: true,
              })
              track(trackingEvents.timeTracking.poolCapacityPressed, {
                option: 'no_limit',
              })
            }}
            label={i18n.t('time_tracking.settings.compensation.no_limit')}
          />
          <ToggleButton
            toggled={!form.isCompensationCapacityUnlimited() || showCustomLimit}
            onClick={() => {
              setShowCustomLimit(true)
              form.setValues({
                has_unlimited_compensation: false,
              })
              track(trackingEvents.timeTracking.poolCapacityPressed, {
                option: 'custom_limit',
              })
            }}
            label={i18n.t('time_tracking.settings.compensation.custom_limit')}
          />
        </Box>
      </Box>
      {showCustomLimit && (
        <Box gap="s8">
          <Box width="full" flexDirection="row" gap="s8">
            <TextField
              value={
                form.isCompensationCapacityUnlimited()
                  ? undefined
                  : form.get('compensation_capacity').value
              }
              onChange={(compensation_capacity) =>
                form.setValues({
                  compensation_capacity: compensation_capacity ? +compensation_capacity : undefined,
                  has_unlimited_compensation: false,
                })
              }
              placeholder={i18n.t('time_tracking.settings.compensation.write_something')}
              hideLabel
              type="number"
              min={1}
            />
            <SelectField
              value={form.get('compensation_units').value}
              options={capacityUnitsOptions()}
              onChange={(selected) => form.setValues({ compensation_units: selected })}
              hideLabel
            />
          </Box>
          <Text size="200" color="grey800">
            {i18n.t('time_tracking.settings.compensation.compensation_warning')}
          </Text>
        </Box>
      )}
    </Box>
  )
}

export default observer(CompensationCapacity)
